export function getActiveSpectrum(state) {
    const { activeSpectra, activeTab } = state.view.spectra;
    const spectra = activeSpectra[activeTab];
    if (spectra?.length === 1) {
        return spectra[0];
    }
    return null;
}
